import { render } from "./ConfigView.vue?vue&type=template&id=63ab5242"
import script from "./ConfigView.vue?vue&type=script&lang=js"
export * from "./ConfigView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__